import React from 'react';
import { Application } from '../../../../../../../../entities/Application';
import { AlertObject } from '../../../../../../../../components/Alert';
import { IconButton } from '../../../../../../../../components/IconButton';
import { NoteModal } from '../../../../../../../../components/ApplicantTracking/NoteModal';
import { useApplicationNoteModal } from '../../useApplicationNoteModal';

interface PropTypes {
  application: Application;
  setAlert: (alert: AlertObject) => void;
  onNoteAdded: () => void;
}

export function AddNote(props: PropTypes) {
  const { isNoteModalOpen, openNoteModal, closeNoteModal, submitNote } =
    useApplicationNoteModal(props);

  return (
    <>
      <NoteModal
        mode='Add'
        onSubmit={submitNote}
        isOpen={isNoteModalOpen}
        disableAlerts={true}
        onClose={closeNoteModal}
      />
      <IconButton
        iconName='bi-file-earmark-text'
        iconClass='text-info'
        buttonClass='me-2h'
        color='secondary'
        tooltipText='Add Note'
        onClick={openNoteModal}
      />
    </>
  );
}
